export const COMPONENT_NAME = 'Top10Events';